<template>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section>
            <div class="grid-x grid-margin-x">
                <div v-if="task && task.taskStatus !== 'SuccessfullyCompleted'" class="cell small-12">
                    <h1 class="text-2xl font-bold">HMRC Agent Delegation</h1>
                    <p>To manage your company's PAYE payroll with HMRC, we need formal authorisation to access your account.</p>
                    <p>This authorisation allows us to:
                        <ul>
                        <li>Receive important notices from HMRC (e.g., tax code updates, student loan notices).</li>
                        <li>Contact HMRC and manage your account on your behalf for matters relating to PAYE</li>
                        </ul>
                    </p>
                    <p>Please authorise our access to your account by following the instructions on <strong><a href="https://www.gov.uk/guidance/authorise-an-agent-for-certain-taxes-through-your-business-tax-account" target="_blank">gov.uk.</a></strong></p>
                    <p>You will need to provide access to Qtac's Agent ID: <strong>tpbatqtac-T44RH9H832HK</strong></p>
                    <p>Once you have completed the authorisation, please return to this page and click the "Confirm" button below.</p>
                    <br/>

                    <label class="custom-check">
                        <input
                            type="checkbox"
                            v-model="isChecked"
                        >I confirm I have followed the instructions to authorise Qtac access to my HMRC account<span class="checkmark"></span>
                    </label> 

                    <br/>
                    <a
                        class="btn btn-primary"
                        @click="markTaskAsComplete"
                        :class="{ disabled: !isChecked }"
                        :aria-disabled="!isChecked"
                        :tabindex="!isChecked ? -1 : 0"
                        @keydown.enter.prevent="isChecked && markTaskAsComplete()"
                        :style="{ pointerEvents: !isChecked ? 'none' : 'auto', opacity: !isChecked ? 0.6 : 1 }"
                    >
                        Confirm
                    </a>
                </div>
                <div v-else class="cell small-12">
                    <h1 class="text-2xl font-bold">HMRC Agent Delegation Complete</h1>
                    <p>Thanks for authorising our access to your HMRC PAYE account.</p>
                    <p>We will now be able to manage your HMRC PAYE account.</p>
                    <br/>
                              <button class="btn btn-secondary" @click="router.back()">Return to Tasks</button>
                </div>
            </div>
        </section>
</div>


  </section>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'


const router  = useRouter()
const route = useRoute();
const loaded = ref(true);

const taskId = route.params.taskId;
const task = ref(null);

const error = ref(false);

const isChecked = ref(false);

import { getDataCollectionTask, putDataCollectionTask } from '@/services/implementationmanagement.api';

const errorString = 'An error has occurred. Please contact your Qtac account manager.';

const markTaskAsComplete = async () => {
    try {

        
        var payload = {
            version: 1,
            dataJson: "",
            schemaName: "HmrcAgentDelegation",
            taskId: taskId,
            taskStatus: "SuccessfullyCompleted"
        }

        var response = await putDataCollectionTask(taskId, payload);

        if (response.status !== 200) {
            error.value = 'Error saving data. Please contact your Qtac account manager.';
            return false;
        }

        router.back();

    } catch (e) {
        error.value = true;
    }
};

onMounted(async () => {

    try {
        var delegationTask = await getDataCollectionTask(taskId);

        if(delegationTask.status !== 200 || delegationTask.data === null || delegationTask.data === undefined) {
            error.value = errorString;
            return null;
        }

        task.value = delegationTask.data;

    } catch (err) {
        error.value = errorString;
        console.error(err);
    }

loaded.value = true;
})

</script>

